module.exports = __webpack_public_path__ + "img/Sweden.66d56709.png";